
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Neuroendocrine_tumors_of_duodenum_and_ampulla_of_Vater",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Neuroendocrine_tumors_of_duodenum_and_ampulla_of_Vater.vue